import { TableCellProps } from "../components/TableCell";
import { AccessorFn, SortingFnOption } from "@tanstack/react-table";

type TableRegisterOptions<T> = {
  sortingFn: SortingFnOption<T>
};

type TableRegisterType<T, TVal> = Omit<TableCellProps<T, TVal>, "header" | "id"> & TableRegisterOptions<TVal>;

export const useTableRegister = <T>() => {
  return <TVal>(key: AccessorFn<T, TVal>, options?: {sortingFn: SortingFnOption<TVal>}) => {
    return {
      accessorFn: key,
      sortingFn: options?.sortingFn ?? "basic"
    } as TableRegisterType<T, TVal>;
  };
};
